import { useState, useEffect } from "react";

function TabNavigation({ tabs, activeTab, onTabChange }) {
  const [activeSubTab, setActiveSubTab] = useState("");

  const currentTab = tabs.find((tab) => tab.title === activeTab);

  useEffect(() => {
    setActiveSubTab("");
  }, [activeTab]);

  const handleSubTabChange = (subTab) => {
    setActiveSubTab(subTab);
    onTabChange(activeTab, subTab);
  };

  return (
    <div className="mt-4 overflow-x-auto border-t">
      {/* Main tabs */}
      <div className="flex space-x-6 pb-2 min-w-max">
        {tabs.map((tab, index) => (
          <TabItem
            key={index}
            name={tab.title}
            icon={tab.icon}
            isActive={tab.title === activeTab}
            onClick={() => onTabChange(tab.title)}
          />
        ))}
      </div>

      {/* Sub-tabs for Professionals */}
      {activeTab === "Professionals" && currentTab?.subCategory && (
        <div className="flex space-x-4 mt-3 pb-2 min-w-max">
          {currentTab.subCategory.map((subTab, index) => (
            <div
              key={index}
              className={`cursor-pointer px-3 py-1 text-sm rounded-md ${
                activeSubTab.title === subTab.title
                  ? "bg-purple-100 text-purple-700 font-medium"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
              onClick={() => handleSubTabChange(subTab)}
            >
              {subTab.title}
            </div>
          ))}
        </div>
      )}

      <div className="h-px bg-gray-200 mt-1"></div>
    </div>
  );
}

function TabItem({ name, icon, isActive, onClick }) {
  return (
    <div
      className={`flex flex-col items-center space-y-1 cursor-pointer relative ${
        isActive ? "opacity-100" : "opacity-80"
      }`}
      onClick={onClick}
    >
      <div className={`p-2 bg-white shadow-sm ${isActive ? "" : ""}`}>
        {icon}
      </div>
      <span
        className={`text-xs whitespace-nowrap ${
          isActive ? "text-black font-medium" : "text-gray-700"
        }`}
      >
        {name}
      </span>
      {isActive && (
        <div className="absolute -bottom-2 w-full h-0.5 bg-black"></div>
      )}
    </div>
  );
}

export default TabNavigation;
